const getStoreConfig = ({ visibleColumns, singleLocation, selectedView }) => {
  return [
    {
      type: "filter",
      key: "location",
      dataKey: "locationName",
      label: "Location",
      className: "region",
      placeholder: "Site",
      visible: visibleColumns.showLocation && selectedView === "individual",
      removeColumn: singleLocation,
      limit: 5
    },
    {
      type: "filter",
      key: "metric",
      dataKey: "title",
      label: "Metric",
      className: "site",
      placeholder: "Goal",
      visible: true
    },
    {
      type: "",
      key: "goalValue",
      label: "Increase",
      className: "current",
      visible: visibleColumns.showIncrease
    },
    {
      type: "sortable",
      key: "goalValue",
      label: "Goal",
      className: "goal",
      visible: true
    },
    {
      type: "sortable",
      key: "currentVal",
      label: "Total",
      className: "current",
      visible: true
    },
    {
      type: "sortable",
      key: "currentValPacing",
      label: "Forecast",
      className: "forecast",
      visible: visibleColumns.showForecast
    },
    {
      type: "sortable",
      key: "needed",
      label: "Needed",
      className: "needed",
      visible: visibleColumns.showNeeded
    },
    {
      type: "sortable",
      key: "progress",
      label: "Progress",
      className: "pacing",
      visible: true
    },
    {
      type: "filter",
      key: "display",
      dataKey: "active",
      label: "Display",
      className: "show-goal",
      visible: visibleColumns.showDisplayDropdown,
      additionalParam: {
        includeSelectAll: true,
        numberDisplayed: 2,
        enableOnly: true,
        haveOnSelectChange: true,
        placeholder: "Show Goal"
      }
    }
  ];
};

const getStaffConfig = ({ visibleColumns, selectedView }) => {
  return [
    {
      key: "entityName",
      label: "Staff",
      type: "filter",
      visible: visibleColumns.showStaff && selectedView === "individual",
      className: "staff",
      dataKey: "entityName"
    },
    {
      key: "metric",
      label: "Metric",
      type: "filter",
      visible: true,
      className: "site",
      dataKey: "title"
    },
    {
      key: "goalValue",
      label: "Increase",
      type: "",
      visible: visibleColumns.showIncrease,
      className: "current"
    },
    {
      key: "goalValue",
      label: "Goal",
      type: "sortable",
      visible: true,
      className: "current"
    },
    {
      key: "currentVal",
      label: "Total",
      type: "sortable",
      className: "current",
      visible: true
    },
    {
      key: "currentValPacing",
      label: "Forecast",
      type: "sortable",
      className: "forecast",
      visible: visibleColumns.showForecast
    },
    {
      key: "needed",
      label: "Needed",
      type: "sortable",
      className: "needed",
      visible: visibleColumns.showNeeded
    },
    {
      key: "progress",
      label: "Progress",
      type: "sortable",
      className: "pacing",
      visible: true
    },
    {
      key: "display",
      label: "Display",
      type: "filter",
      dataKey: "active",
      className: "show-goal",
      visible: visibleColumns.showDisplayDropdown,
      additionalParam: {
        includeSelectAll: true,
        numberDisplayed: 2,
        enableOnly: true,
        haveOnSelectChange: true,
        placeholder: "Show Goal"
      }
    }
  ];
};

export const getGoalsHeaderConfig = ({
  visibleColumns,
  singleLocation,
  selectedModuleView,
  selectedView
}) => {
  if (selectedModuleView === "staff") {
    return getStaffConfig({ visibleColumns, selectedView });
  } else {
    return getStoreConfig({ visibleColumns, singleLocation, selectedView });
  }
};
